import React, { useState, useRef, useEffect } from "react";
import upload from "../assets/images/upload.png";
import HeaderLeft from "./HeaderLeft";
import { useNavigate } from "react-router-dom";
import http from "../services/http";
import GetStorage from "../services/Storage";
import DropdownRight from "./DropdownRight";

const WelcomeJosh = () => {
  const inputFileRef = useRef(null);
  const onBtnClick = () => {
    inputFileRef.current.click();
  };
  useEffect(() => {
    if (user.data.image) {
      setPicture(user.data.image);
      setPicUpload(true)
    }
  }, []);

  const [picture, setPicture] = useState(upload);
  const [photo, setPhoto] = useState(null);
  const [error, setError] = useState("");
  const [isPicUpload, setPicUpload] = useState(false);

  const token = GetStorage.get("xAuthToken");
  const navigate = useNavigate();

  let user = localStorage.getItem("user");
  user = JSON.parse(user);

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      let img = event.target.files[0];
      setPhoto(img);
      const pictureToShow = URL.createObjectURL(img);

      setPicture(pictureToShow);
      setPicUpload(true);
      setError("");
    }
  };

  const handleSubmit = async () => {
    if (!isPicUpload) {
      setError("Please upload a photo.");
      // navigate("/welcomePersonalInfo");
      return;
    }
    var formData = new FormData();

    formData.append("image", photo);

    if(photo){
      http
        .put(`api/analyst/profile-img?token=${token}`, formData)
        .then((res) => {
          console.log("response  ------->>>>", res.data);
  
          navigate("/welcomePersonalInfo");
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.errors) {
              for (let key in error.response.data.errors) {
                setError(error.response.data.errors[key]);
              }
            } else if (error.response.data.message) {
              setError(error.response.data.message);
            }
          }
        });
    }else if(picture){
      navigate("/welcomePersonalInfo");
    }
  };

  return (
    <>
      <header>
        <div className="custom_container ">
          <HeaderLeft />
          <div className="user_profile">
            <DropdownRight />
          </div>
        </div>
      </header>
      <section className="otp_verification custom_hight">
        <div className="login_inner">
          <h1 className="mb_30 main_title ">Welcome {user.data.firstname}!</h1>
          <p className="mb_40 them_para text-center mx-auto text_limit">
            Set up your profile now... Select a profile picture.
          </p>
          <h6 className="sub_title mb_30">Set up your profile!</h6>
          <div className="upload_img mb_30">
            {" "}
            <input
              type="file"
              ref={inputFileRef}
              onChange={onImageChange}
              style={{ display: "none" }}
            />
            <img
              alt="profile"
              src={picture}
              onClick={onBtnClick}
              style={{
                width: 150,
                height: 150,
                border: "1px solid gray",
                padding: 5,
                borderRadius: "50%",
              }}
            />
          </div>
          <h5 style={{ color: "red" }}>{error}</h5>
          <div className="btn_wraper">
            <button
              type="button"
              className="them_btn mt_40 mb_30"
              onClick={handleSubmit}
            >
              {!isPicUpload ? "Upload Photo" :"Next"}
              {/* {photo ? "upload Photo" : "Skip >>"} */}
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default WelcomeJosh;
